import request from "../../utils/request";
const url = process.env.VUE_APP_BASE_API;

const AuthResource = {
  login(data) {
    return request({
      url: `${url}/account/login`,
      method: "POST",
      data
    });
  },
  loginFb(params) {
    return request({
      url: "http://graph.facebook.com/oauth/authorize",
      method: "GET",
      params
    });
  }
};
export { AuthResource as default };
